import React from 'react';
import { Img } from './styles';

export interface Props {
  svg: string;
  openCollapsible?: boolean;
  alt?: string;
  width?: string;
  onClick?: () => void;
}

export default function Icon({
  svg,
  openCollapsible = false,
  alt,
  width,
  onClick,
}: Props) {
  return (
    <>
      <Img
        src={svg}
        openCollapsible={openCollapsible}
        alt={alt}
        onClick={onClick}
        aria-hidden="true"
        width={width}
      />
    </>
  );
}
